module.exports = __webpack_public_path__ + "static/img/case_16.14b0328.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_16.jpg
// module id = 3wUh
// module chunks = 0